import { logError } from '../utils/errorHandling';

/**
 * Key for storing cart ID in localStorage
 */
const CART_ID_STORAGE_KEY = 'cartId';

/**
 * CartStorage utility for handling cart ID persistence
 * Now the cart data is stored on the backend, we only store the cart ID locally
 */
export const cartStorage = {
  /**
   * Get cart ID from localStorage or cache
   */
  getCartId: (): string | null => {
    try {
      const isBrowser = typeof window !== 'undefined';

      if (!isBrowser) {
        return null;
      }
      
      const storedCartId = localStorage.getItem(CART_ID_STORAGE_KEY);
      
      return storedCartId;
    } catch (error) {
      logError('CartStorage.getCartId', error);
      return null;
    }
  },
  
  /**
   * Save cart ID to localStorage and update cache
   */
  saveCartId: (cartId: string): void => {
    try {
      localStorage.setItem(CART_ID_STORAGE_KEY, cartId);
    } catch (error) {
      logError('CartStorage.saveCartId', error);
    }
  },
  
  /**
   * Clear cart ID from localStorage and cache
   */
  clearCartId: (): void => {
    try {
      localStorage.removeItem(CART_ID_STORAGE_KEY);
    } catch (error) {
      logError('CartStorage.clearCartId', error);
    }
  }
}; 